import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const ErrorBoundary = () => {
  const error = useRouteError();
  if (!isRouteErrorResponse(error)) {
    throw error;
  }

  return (
    <Container style={{ textAlign: 'center', marginTop: '50px' }}>
      <Typography variant="h1" component="h1" gutterBottom>
        {error.status}
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom>
        {error.statusText}
      </Typography>
      {error.data?.message &&
        <Typography variant="body1" gutterBottom>
          {error.data.message}
        </Typography>
      }
      <Button variant="contained" color="primary" href="/">
        Go to Home
      </Button>
    </Container>
  );
};

export default ErrorBoundary;